import * as types from '../actionTypes';

export function showTokenValidationFailedModal() {
    return {type: types.SHOW_TOKEN_VALIDATION_FAILED_MODAL, status: true};
}


// WEBPACK FOOTER //
// ./web/src/actions/resource/resourceActions.js